import { render, staticRenderFns } from "./AltUpsell.vue?vue&type=template&id=500061b4"
import script from "./AltUpsell.vue?vue&type=script&lang=js"
export * from "./AltUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports